import Vue from 'vue';

export const rDiaEvents = new Vue({});
